const state = {
    mode: '',
    billhead: null,
    billdetail: null,
    approvallist: null,
}

const mutations = {
    Set_Mode(state, val) {
        state.mode = val
    },
    Set_Bil_Head(state, val) {
        state.billhead = val
    },
    Set_Bil_Detail(state, val) {
        state.billdetail = val
    },
    Set_Approval_List(state, val) {
        state.approvallist = val
    },
}

const actions = {
    setIsEdit: ({ commit }, val) => {
        commit('setIsEdit', val)
    },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
